module.exports = __webpack_public_path__ + "img/green-2-diamond-open.0f02328d.svg";